import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default withParallax(styled.h2`
  opacity: 0.7;
  font-family: 'Galano Classic';
  font-size: 0.5rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.84px;
  padding: 0;
  margin: 0;

  ${media.medium`
    font-size: 0.7rem;
    letter-spacing: 0.07rem;
  `}
`);
